import * as t from "react";
import a from "../lib/IconBase.es.js";
import s from "../defs/ListHeart.es.js";
const e = t.forwardRef((o, r) => /* @__PURE__ */ t.createElement(a, { ref: r, ...o, weights: s }));
e.displayName = "ListHeartIcon";
const c = e;
export {
  c as ListHeart,
  e as ListHeartIcon
};
